import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { ITextProps } from '../components/text/text';

export class TextModel extends ContentItem {
  get id(): string {
    return get(this._config, 'id', '');
  }

  get text(): string {
    return get(this._config, 'elements.text_value.value', '');
  }

  get type(): string {
    return get(this._config, 'elements.type.value[0].codename', '');
  }

  get size(): string {
    return get(this._config, 'elements.size.value[0].codename', '');
  }

  get textColor(): string {
    return get(
      this._config,
      'elements.color__text_color.value[0].codename',
      ''
    );
  }

  get bgColor(): string {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      ''
    );
  }

  get textAlign(): string {
    return get(this._config, 'elements.text_align.value[0].codename', '');
  }

  get hasLineOver(): boolean {
    return (
      get(
        this._config,
        'elements.has_line_over_text.value[0].codename',
        false
      ) === 'true'
    );
  }

  public static create(data: IText): ITextProps {
    const {
      id,
      text,
      type,
      size,
      textColor,
      textAlign,
      bgColor,
      hasLineOver
    } = new TextModel(data);
    return {
      id,
      text,
      type,
      size,
      textColor,
      textAlign,
      bgColor,
      hasLineOver
    };
  }
}
